export const defaultTenant = "Vistaprint";
